import { FlexiButton } from "@flexinet/ui-components";
import { Message, MessagePatch, MessageStatus } from "../types";
import { MdMarkEmailUnread } from "react-icons/md";

interface MarkAsUnreadButtonProps {
    record: Message;
    onClick: (patch: MessagePatch) => void;
}

export const MarkAsUnreadButton = ({ onClick }: MarkAsUnreadButtonProps) => {
    return (
        <FlexiButton 
            variant={'outline'}
            leftSection={<MdMarkEmailUnread />}
            onClick={() => onClick({ status: MessageStatus.UNREAD })}
        >
            Mark as Unread
        </FlexiButton>
    );
};
